import { Theme, LIGHT_THEME, ThemeFactory } from "react-ui";
import { KonturColors } from "@skbkontur/colors";

const overrideVariables = {
    tabColorFocus: KonturColors.grayscaleText,
    tabColorHover: KonturColors.grayscale10Background,
    // loaderBg: "#f3f3f3", -- вот это я ваще не понял зачем мы сделали?
    // на сервисе сотрудников это выглядит оч плохо - завели багу
    loaderOpacity: "0.8",
    borderColorGrayLight: KonturColors.shade16Black,
    borderColorGrayDark: KonturColors.shade16Black,
    blinkColor: "rgba(61, 61, 61, 0.2)",
    linkActiveColor: KonturColors.blue110,
    linkColor: KonturColors.mainLinkTextBlue90,
    linkHoverColor: KonturColors.linkStatesTextHoverBlue100,
    linkTextDecoration: "none", // отключаем подчеркивание с коробки
    pagingPageForwardLinkMarginTop: "4px", // сервис сотрудников без этого не работает корректно
};

export const reactUIDefaultTheme: Theme = ThemeFactory.create(overrideVariables, LIGHT_THEME);
